import React, { useEffect, useState } from "react";
import { useGlobalContext } from "../context/globalContext";
import { Toaster, toast } from "react-hot-toast";
import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import { storage } from "../firebase.config";
import SearchableDropdown from "../components/SearchableDropdown";

function Home() {
    const { userInfo, queryType, setQueryType } = useGlobalContext();
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({});
    const [fileObj, setFileObj] = useState(null);
    const [courses, setCourses] = useState([]);
    const [coursesList, setCoursesList] = useState([]);

    // Resolve API URL dynamically based on environment
    const getApiUrl = (path) => {
        const isLocal = window.location.hostname === "localhost";
        const base = isLocal ? "http://localhost:3000" : "https://66z6lhu4ge.execute-api.ap-south-1.amazonaws.com/prod";
        return `${base}${path}`;
    };

    useEffect(() => {
        const fetchCoursesList = async () => {
            try {
                const response = await fetch(getApiUrl("/api/courses"));
                if (response.ok) {
                    const data = await response.json();
                    setCourses(data.map(c => c.course_name));
                    setCoursesList(data);
                }
            } catch (err) {
                console.error("Error fetching courses list:", err);
            }
        };
        fetchCoursesList();
    }, []);

    const handleCourseSelect = (fieldName, courseValue) => {
        setFormData((prev) => {
            const updatedFields = {
                ...prev.fields,
                [fieldName]: courseValue,
                taken_by: userInfo?.email,
                status: "PENDING",
                comment: " "
            };

            // Auto-populate newCourseId for UPI payment query
            if (fieldName === "new_course" && queryType === "UPIpayment") {
                const matchedCourse = coursesList.find(c => c.course_name === courseValue);
                if (matchedCourse && matchedCourse.plan_id) {
                    updatedFields.newCourseId = matchedCourse.plan_id;
                } else {
                    updatedFields.newCourseId = "";
                }
            }

            return {
                ...prev,
                fields: updatedFields
            };
        });
    };

    const handleFileChange = (event) => {
        setFileObj(event.target.files[0]);
        console.log(event.target.files[0]);
    };

    const uploadFiletoCloud = async () => {
        const now = new Date();
        const monthYear = `${now.getMonth() + 1}-${now.getFullYear()}`;
        const dayTime = `${now.getDate()}/${now.toLocaleTimeString("en-IN", {
            hour12: false,
        })}`;
        const storageRef = ref(
            storage,
            `${monthYear}/${dayTime}-${fileObj.name}`
        );

        try {
            toast.loading("Uploading File");
            setLoading(true);

            const snapshot = await uploadBytes(storageRef, fileObj);
            const fileurl = await getDownloadURL(storageRef);

            toast.dismiss();
            toast.success("File Uploaded");

            return fileurl;
        } catch (err) {
            console.error(err);
            toast.dismiss();
            toast.error("Problem while uploading file");
        } finally {
            setLoading(false);
        }
    };

    const handleInput = (e) => {
        let value = e.target.value;
        if (e.target.name === "amount") {
            value = value.replace(/\D/g, "");
            e.target.value = value;
        }
        setFormData((prev) => ({
            ...prev,
            fields: {
                ...prev.fields,
                [e.target.name]: value,
                taken_by: userInfo.email,
                status: "PENDING",
                comment: " "
            }
        }));
    };

    useEffect(() => {
        if (!localStorage.getItem("queryType")) {
            localStorage.setItem("queryType", "nameChange");
        }
        // Initialize formData with queryType
        setFormData({
            queryType: queryType,
            fields: {}
        });
    }, [queryType]);

    const clearInput = () => {
        const inputFields = document.querySelectorAll("input");
        inputFields.forEach((input) => {
            input.value = "";
        });
        const textFields = document.querySelectorAll("textarea");
        textFields.forEach((input) => {
            input.value = "";
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Custom validation for UPI payment query
        if (queryType === "UPIpayment") {
            if (!formData.fields?.new_course) {
                toast.error("Upgrade course is required");
                return;
            }
            if (!fileObj) {
                toast.error("File upload (Screenshot) is required");
                return;
            }
        }

        setLoading(true);

        let submissionData = formData;
        if (fileObj !== null) {
            const fileurl = await uploadFiletoCloud();
            submissionData = {
                ...formData,
                fields: {
                    ...formData.fields,
                    file: fileurl
                }
            };
        }

        try {
            toast.loading("Adding Query...");
            console.log("Submitting data:", submissionData);

            const response = await fetch(
                "https://66z6lhu4ge.execute-api.ap-south-1.amazonaws.com/prod/api/queries",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(submissionData)
                }
            );

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(`${errorData.error || 'Unknown error'} \nStatus: ${response.status}`);
            }

            const result = await response.json();
            console.log("Response:", result);
            clearInput();
            toast.dismiss();
            toast.success("Query added successfully!");
        } catch (error) {
            toast.dismiss();
            toast.error(error.message);
            console.error("Error:", error);
        } finally {
            setLoading(false);
        }
    };


    return (
        <>

            <Toaster
                position="bottom-left"
                toastOptions={{
                    // Define default options
                    className: "",

                    style: {
                        background: "#ff8e00",
                        color: "#2e2c2d",
                    },

                    // Default options for specific types
                    success: {
                        duration: 2000,
                        theme: {
                            primary: "green",
                            secondary: "black",
                        },
                    },
                }}
            />
            <div className="h-screen overflow-scroll flex flex-col items-center  text-black text-base   w-full py-5">
                <h1 className="w-full block p-2 font-semibold text-xl text-center">
                    Add new query
                </h1>
                <form
                    className="flex flex-col gap-5 rounded  justify-center w-full md:w-2/3 lg:w-1/2 m-2 mb-5"
                    onSubmit={handleSubmit}
                >
                    <div className="flex flex-col">
                        <label className=" mx-1 font-semibold">Type</label>
                        <select
                            className="w-full  px-3 py-2 rounded-lg  text-lg outline-none  border border-theme-dark hover:border-theme-yellow-dark cursor-pointer"
                            value={queryType}
                            onChange={(e) => {
                                setQueryType(e.target.value)
                                localStorage.setItem("queryType", e.target.value);
                            }}
                        >
                            <option value="nameChange">Name Change</option>
                            <option value="batchShift">Batch Shift</option>
                            <option value="emi">EMI</option>
                            <option value="refund">Refund</option>
                            <option value="removeCourseAccess">Remove Course Access</option>
                            <option value="feedback">Feedback</option>

                            <option value="numberchange">Number change</option>
                            <option value="emailchange">Email change</option>
                            <option value="contentmissing">Content Missing</option>
                            <option value="coursenotvisible">Course Not Visible</option>
                            <option value="UPIpayment">UPI Payment</option>
                            <option value="grpnotalloted">Group not alloted</option>
                            <option value="technicalIssue">Technical Issue</option>
                            <option value="misc">Misc</option>
                        </select>
                    </div>

                    {queryType != "nameChange" && (
                        <div className="flex flex-col">
                            <label className=" mx-1 font-semibold">Name</label>
                            <input
                                placeholder="Name"
                                name="name"
                                className="text-black rounded-md p-2 outline-theme-yellow-dark border border-theme-dark"
                                onChange={handleInput}
                                required
                            />
                        </div>
                    )}

                    {queryType == "nameChange" ? (
                        <>
                            <div className="flex flex-col">
                                <label className=" mx-1 font-semibold">Old Name</label>
                                <input
                                    placeholder="Old Name"
                                    name="name"
                                    className="text-black rounded-md p-2 outline-theme-yellow-dark border border-theme-dark"
                                    onChange={handleInput}
                                    required
                                />
                            </div>
                            <div className="flex flex-col">
                                <label className=" mx-1 font-semibold">New Name</label>
                                <input
                                    placeholder="New Name"
                                    name="new_name"
                                    className="text-black rounded-md p-2 outline-theme-yellow-dark border border-theme-dark"
                                    onChange={handleInput}
                                    required
                                />
                            </div>
                        </>
                    ) : null}

                    {queryType == "emailchange" ? (
                        <>
                            <div className="flex flex-col ">
                                <label className=" mx-1 font-semibold">Old Email</label>
                                <input
                                    type="email"
                                    placeholder="Old email"
                                    required
                                    name="email"
                                    className="text-black rounded-md p-2 outline-theme-yellow-dark border border-theme-dark"
                                    onChange={handleInput}
                                />
                            </div>
                            <div className="flex flex-col  ">
                                <label className=" mx-1 font-semibold">New Email</label>
                                <input
                                    type="email"
                                    placeholder="New email"
                                    required
                                    name="new_email"
                                    className="text-black rounded-md p-2 outline-theme-yellow-dark border border-theme-dark"
                                    onChange={handleInput}
                                />
                            </div>
                        </>
                    ) : (
                        <div className="flex flex-col ">
                            <label className=" mx-1 font-semibold">Email</label>
                            <input
                                type="email"
                                placeholder="Email"
                                required
                                name="email"
                                className="text-black rounded-md p-2 outline-theme-yellow-dark border border-theme-dark"
                                onChange={handleInput}
                            />
                        </div>
                    )}

                    {queryType == "numberchange" ? (
                        <>
                            <div className="flex flex-col ">
                                <label className=" mx-1 font-semibold">Old Number</label>
                                <input
                                    type="text"
                                    placeholder="Old number"
                                    required
                                    name="number"
                                    className="text-black rounded-md p-2 outline-theme-yellow-dark border border-theme-dark"
                                    onChange={handleInput}
                                />
                            </div>
                            <div className="flex flex-col ">
                                <label className=" mx-1 font-semibold">New Number</label>
                                <input
                                    type="text"
                                    placeholder="New number"
                                    required
                                    name="new_number"
                                    className="text-black rounded-md p-2 outline-theme-yellow-dark border border-theme-dark"
                                    onChange={handleInput}
                                />
                            </div>
                        </>
                    ) : (
                        <div className="flex flex-col ">
                            <label className=" mx-1 font-semibold">Number</label>
                            <input
                                type="text"
                                placeholder="Number"
                                name="number"
                                className="text-black rounded-md p-2 outline-theme-yellow-dark border border-theme-dark"
                                onChange={handleInput}
                                required
                            />
                        </div>
                    )}

                    {(queryType === "batchShift" ||
                        queryType === "UPIpayment" ) ? (
                        <div className="flex flex-col ">
                            <label className=" mx-1 font-semibold">Amount</label>
                            <input
                                type="text"
                                placeholder="Amount"
                                name="amount"
                                className="text-black rounded-md p-2 outline-theme-yellow-dark border border-theme-dark"
                                value={formData.fields?.amount || ""}
                                onChange={handleInput}
                                required={queryType === "UPIpayment"}
                            />
                        </div>
                    ) : null}
                    {queryType === "batchShift" ? (
                        <>
                            <div className="flex flex-col ">
                                <label className=" mx-1 font-semibold">Current Batch</label>
                                <input
                                    placeholder="Current batch"
                                    name="current_batch"
                                    className="text-black rounded-md p-2 outline-theme-yellow-dark border border-theme-dark"
                                    onChange={handleInput}
                                />
                            </div>
                            <div className="flex flex-col ">
                                <label className=" mx-1 font-semibold">New Batch</label>
                                <input
                                    placeholder="New batch"
                                    name="new_batch"
                                    className="text-black rounded-md p-2 outline-theme-yellow-dark border border-theme-dark"
                                    onChange={handleInput}
                                />
                            </div>
                        </>
                    ) : null}

                    {queryType === "refund" ||
                    queryType === "removeCourseAccess" ||
                    queryType === "feedback" || queryType === "technicalIssue" ? (
                        <div className="flex flex-col ">
                            <label className=" mx-1 font-semibold">Course Name</label>
                            <input
                                placeholder="Course name"
                                name="current_course"
                                className="text-black rounded-md p-2 outline-theme-yellow-dark border border-theme-dark"
                                onChange={handleInput}
                            />
                        </div>
                    ) : null}



                    {queryType === "batchShift" ||
                    queryType === "refund" ||
                    queryType === "removeCourseAccess" ? (
                        <div className="flex flex-col ">
                            <label className=" mx-1 font-semibold">Reason</label>
                            <input
                                placeholder="Reason"
                                name="reason"
                                className="text-black rounded-md p-2 outline-theme-yellow-dark border border-theme-dark"
                                onChange={handleInput}
                            />
                        </div>
                    ) : null}

                    {queryType === "emi" ? (
                        <>
                            <div className="flex flex-col ">
                                <label className=" mx-1 font-semibold">Course Name</label>
                                <input
                                    placeholder="Current course"
                                    name="current_course"
                                    className="text-black rounded-md p-2 outline-theme-yellow-dark border border-theme-dark"
                                    onChange={handleInput}
                                />
                            </div>
                            <div className="flex flex-col ">
                                <label className=" mx-1 font-semibold">First Installment</label>
                                <input
                                    type="text"
                                    placeholder="First Installment"
                                    name="first_installment"
                                    className="text-black rounded-md p-2 outline-theme-yellow-dark border border-theme-dark"
                                    onChange={handleInput}
                                />
                            </div>
                            <div className="flex flex-col ">
                                <label className=" mx-1 font-semibold">
                                    Second Installment
                                </label>
                                <input
                                    type="text"
                                    placeholder="Second Installment"
                                    name="second_installment"
                                    className="text-black rounded-md p-2 outline-theme-yellow-dark border border-theme-dark"
                                    onChange={handleInput}
                                />
                            </div>
                        </>
                    ) : null}

                    {queryType == "contentmissing" ? (
                        <>
                            <div className="flex flex-col ">
                                <label className=" mx-1 font-semibold">Course Name</label>
                                <input
                                    placeholder="Course name"
                                    required
                                    name="current_course"
                                    className="text-black rounded-md p-2 outline-theme-yellow-dark border border-theme-dark"
                                    onChange={handleInput}
                                />
                            </div>
                            <div className="flex flex-col ">
                                <label className=" mx-1 font-semibold">Content</label>
                                <input
                                    placeholder="Content"
                                    required
                                    name="content_desc"
                                    className="text-black rounded-md p-2 outline-theme-yellow-dark border border-theme-dark"
                                    onChange={handleInput}
                                />
                            </div>
                        </>
                    ) : null}

                    {queryType == "coursenotvisible" ? (
                        <>
                            <div className="flex flex-col ">
                                <label className=" mx-1 font-semibold">Course Name</label>
                                <input
                                    placeholder="Course name"
                                    required
                                    name="current_course"
                                    className="text-black rounded-md p-2 outline-theme-yellow-dark border border-theme-dark"
                                    onChange={handleInput}
                                />
                            </div>
                            <div className="flex flex-col ">
                                <label className=" mx-1 font-semibold">Content</label>
                                <input
                                    placeholder="Content"
                                    required
                                    name="content_desc"
                                    className="text-black rounded-md p-2 outline-theme-yellow-dark border border-theme-dark"
                                    onChange={handleInput}
                                />
                            </div>
                        </>
                    ) : null}

                    
                    {/* ✅ NEW: Only for UPI Payment — UTR and New Course ID */}
                    {queryType === "UPIpayment" && (
                        <>
                            <div className="flex flex-col">
                                <label className="mx-1 font-semibold">UTR Number</label>
                                <input
                                    type="text"
                                    placeholder="Enter UTR number"
                                    name="utr"
                                    className="text-black rounded-md p-2 outline-theme-yellow-dark border border-theme-dark"
                                    onChange={handleInput}
                                    required
                                />
                            </div>

                            <div className="flex flex-col">
                                <label className="mx-1 font-semibold">Student/User ID</label>
                                <input
                                    type="text"
                                    placeholder="Enter Student/User ID"
                                    name="student_user_id"
                                    className="text-black rounded-md p-2 outline-theme-yellow-dark border border-theme-dark"
                                    onChange={handleInput}
                                />
                            </div>

                             <div className="flex flex-col">
                                 <label className="mx-1 font-semibold">New Course ID</label>
                                 <input
                                     type="text"
                                     placeholder="Auto-populated from course selection"
                                     name="newCourseId"
                                     className="text-black rounded-md p-2 outline-theme-yellow-dark border border-theme-dark bg-gray-100 cursor-not-allowed"
                                     value={formData.fields?.newCourseId || ""}
                                     readOnly
                                     required
                                 />
                             </div>
                        </>
                    )}

                    {queryType == "grpnotalloted" ? (
                        <div className="flex flex-col ">
                            <label className=" mx-1 font-semibold">Course Name</label>
                            <input
                                placeholder="Course name"
                                required
                                name="current_course"
                                className="text-black rounded-md p-2 outline-theme-yellow-dark border border-theme-dark"
                                onChange={handleInput}
                            />
                        </div>
                    ) : null}

                    {queryType == "feedback" ? (
                        <div className="flex flex-col ">
                            <label className=" mx-1 font-semibold">Feedback</label>
                            <input
                                placeholder="Feedback"
                                required
                                name="feedback"
                                className="text-black rounded-md p-2 outline-theme-yellow-dark border border-theme-dark"
                                onChange={handleInput}
                            />
                        </div>
                    ) : null}
                    {queryType == "UPIpayment" || queryType == "misc" ? (
                        <>
                            <div className="flex flex-col ">
                                <label className=" mx-1 font-semibold">Current Course</label>
                                <SearchableDropdown
                                    options={courses}
                                    value={formData.fields?.current_course || ""}
                                    onChange={(val) => handleCourseSelect("current_course", val)}
                                    placeholder="Search & select current course"
                                />
                            </div>
                            <div className="flex flex-col ">
                                <label className=" mx-1 font-semibold">
                                    Upgrade to which course
                                </label>
                                <SearchableDropdown
                                    options={courses}
                                    value={formData.fields?.new_course || ""}
                                    onChange={(val) => handleCourseSelect("new_course", val)}
                                    placeholder="Search & select upgrade course"
                                />
                            </div>
                        </>
                    ) : null}


                    {
                        queryType === "technicalIssue" && (
                            <>
                                <div className="flex flex-col ">
                                    <label className=" mx-1 font-semibold">Device Name</label>
                                    <input
                                        type="text"
                                        placeholder="Device name"
                                        name="deviceName"
                                        className="text-black rounded-md p-2 outline-theme-yellow-dark border border-theme-dark"
                                        onChange={handleInput}
                                    />
                                </div>
                                <div className="flex flex-col ">

                                    <label className=" mx-1 font-semibold">Device Specifications</label>
                                    <textarea
                                        placeholder="Device Specifications"
                                        name="deviceSpecs"
                                        className="text-black rounded-md p-2 outline-theme-yellow-dark border border-theme-dark"
                                        onChange={handleInput}
                                    />
                                </div>
                            </>
                        )
                    }

                    {queryType == "coursenotvisible" ||
                    queryType == "UPIpayment" ||
                    queryType == "misc" ||
                    queryType == "batchShift" ||
                    queryType == "emi" ||
                    queryType == "feedback" || queryType === "technicalIssue" ? (
                        <div className="flex flex-col ">
                            <label className="  mx-1 font-semibold">File Upload</label>
                            <input
                                type="file"
                                name="file"
                                className="rounded-md p-2 outline-theme-yellow-dark border-none"
                                onChange={handleFileChange}
                            />
                        </div>
                    ) : null}
                    <div className="flex flex-col ">
                        <label className=" mx-1 font-semibold">Issue</label>
                        <textarea
                            placeholder="Details about the issue"
                            name="query_desc"
                            className="text-black rounded-md p-2 outline-theme-yellow-dark border border-theme-dark"
                            onChange={handleInput}
                        />
                    </div>

                    <button
                        type="submit"
                        className="bg-theme-yellow-dark hover:bg-theme-dark font-bold hover:text-theme-yellow-dark w-1/2 px-5 py-2 rounded-lg mx-auto mt-2"
                        disabled={loading}
                    >
                        {loading ? (
                            <i className="fa-solid fa-spinner animate-spin"></i>
                        ) : (
                            "Submit"
                        )}
                    </button>
                </form>
            </div>
        </>
    );
}

export default Home;
